// @ts-nocheck
import React from 'react';
import cn from 'classnames'
import classes from './Mobile.module.scss'
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const buildName = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' ? window.REACT_APP_BUILD_NAME : process.env.REACT_APP_BUILD_NAME || 'tazadeal';
const iosLink = buildName === 'tazadeal'
  ? window.REACT_APP_IOS_LINK_TAZA !== 'REPLACE_REACT_APP_IOS_LINK_TAZA' ? window.REACT_APP_IOS_LINK_TAZA : process.env.REACT_APP_IOS_LINK_TAZA
  : window.REACT_APP_IOS_LINK_ATHENA !== 'REPLACE_REACT_APP_IOS_LINK_ATHENA' ? window.REACT_APP_IOS_LINK_ATHENA : process.env.REACT_APP_IOS_LINK_ATHENA;

const googleLink = buildName === 'tazadeal'
  ? window.REACT_APP_GOOGLE_LINK_TAZA !== 'REPLACE_REACT_APP_GOOGLE_LINK_TAZA' ? window.REACT_APP_GOOGLE_LINK_TAZA : process.env.REACT_APP_GOOGLE_LINK_TAZA
  : window.REACT_APP_GOOGLE_LINK_ATHENA !== 'REPLACE_REACT_APP_GOOGLE_LINK_ATHENA' ? window.REACT_APP_GOOGLE_LINK_ATHENA : process.env.REACT_APP_GOOGLE_LINK_ATHENA

const apkLink = buildName === 'tazadeal'
  ? window.REACT_APP_APK_LINK_TAZA !== 'REPLACE_REACT_APP_APK_LINK_TAZA' ? window.REACT_APP_APK_LINK_TAZA : process.env.REACT_APP_APK_LINK_TAZA
  : window.REACT_APP_APK_LINK_ATHENA !== 'REPLACE_REACT_APP_APK_LINK_ATHENA' ? window.REACT_APP_APK_LINK_ATHENA : process.env.REACT_APP_APK_LINK_ATHENA

const rustoreLink = buildName === 'tazadeal'
  ? window.REACT_APP_RUSTORE_LINK_TAZA !== 'REPLACE_REACT_APP_RUSTORE_LINK_TAZA' ? window.REACT_APP_RUSTORE_LINK_TAZA : process.env.REACT_APP_RUSTORE_LINK_TAZA
  : window.REACT_APP_RUSTORE_LINK_ATHENA !== 'REPLACE_REACT_APP_RUSTORE_LINK_ATHENA' ? window.REACT_APP_RUSTORE_LINK_ATHENA : process.env.REACT_APP_RUSTORE_LINK_ATHENA

const Mobile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const appName = buildName === 'tazadeal' ? 'Tazadeal' : 'Athena'

  React.useEffect(() => {
    const isMobile = /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(navigator.userAgent)
    if (!isMobile) navigate('/');
  }, []);

  return (
    <div className={classes.wrapper}>
        <div className={cn(classes.text, classes.title)}>{t('MobileApp.banner.welcomeUser')}</div>
        <div className={classes.text}>{t('MobileApp.banner.notSupported')}</div>
        <div className={classes.text}>{t('MobileApp.banner.installApp', { appName })}</div>
        <div className={classes.linkWrap}>
            {iosLink && <a href={iosLink} className={cn(classes.link, classes.apple)} />}
            {apkLink && <a href={apkLink} className={cn(classes.link, classes.apk)} />}
            {googleLink && <a href={googleLink} className={cn(classes.link, classes.googlePlay)} />}
            {rustoreLink && <a href={rustoreLink} className={cn(classes.link, classes.rustore)} />}
        </div>
    </div>
  )
}

export default Mobile
